export const courses = {
  data() {
    return {
      courseval: {
        // cse
        options1: [
          { credit: null, value: null, text: "Please select an option" },
          { credit: 3, value: 1, text: "ENG-MATHS 1" },
          { credit: 4, value: 2, text: "c programming" },
          { credit: 3, value: 3, text: "python" },
          { credit: 3, value: 4, text: "DHV" },
          { credit: 3, value: 5, text: "ENG-maths 2" },
          { credit: 4, value: 6, text: "Data Structure using C" },
          { credit: 5, value: 7, text: "Digital Electronics" },
          { credit: 4, value: 8, text: "Basic Electronics" },
          { credit: 1, value: 9, text: "workshop" },
          { credit: 1, value: 10, text: "Engineering Graphics" },
          { credit: 3, value: 11, text: "Professional Communication" },
          { credit: 4, value: 12, text: "Engineering Physics" },
          {
            credit: 1,
            value: 13,
            text: "Intro to computer science Engineering",
          },
          { credit: 1, value: 14, text: "Language Lab" },
          { credit: 4, value: 15, text: "Theory of Computation" },
          { credit: 4, value: 16, text: "Operating System" },
          { credit: 4, value: 17, text: "Object Oriented Programming" },
          { credit: 3, value: 18, text: "Discrete Structures" },
          { credit: 4, value: 19, text: "Microprocessors(3-sem)" },
          { credit: 3, value: 20, text: "Introduction to logic" },
          { credit: 2, value: 21, text: "Enterpreneurship" },
          { credit: 5, value: 22, text: "Computer Networks" },
          { credit: 4, value: 23, text: "Computer Organization" },
          { credit: 5, value: 24, text: "Design & analysis of Algorithms" },
          { credit: 5, value: 25, text: "Database Management" },
          { credit: 4, value: 26, text: "Engineering Computational methods" },
          { credit: 2, value: 27, text: "Microprocessors(5-sem)" },
          { credit: 4, value: 28, text: "Compiler Design" },
          { credit: 5, value: 29, text: "Java Programming" },
          { credit: 4, value: 30, text: "Artificial Intelligence" },
          { credit: 1, value: 31, text: "Adobe Lab" },
          { credit: 2, value: 32, text: "Mini Project" },
          { credit: 4, value: 33, text: "IOT" },
          { credit: 4, value: 34, text: "Python(6-sem)" },
          { credit: 4, value: 35, text: "Software Engineering" },
          { credit: 4, value: 36, text: "Soft Computing" },
          { credit: 5, value: 37, text: "Machine Learning" },
          { credit: 4, value: 38, text: "Computer Network Security" },
          { credit: 3, value: 39, text: "Colloquium" },
          { credit: 3, value: 40, text: "Mobile communication" },
          { credit: 3, value: 41, text: "Computer Network Security(7-sem)" },
          { credit: 3, value: 42, text: "Data science and analytics" },
          { credit: 4, value: 43, text: "Compiler Design" },
          { credit: 3, value: 44, text: "School Elective-III" },
          { credit: 3, value: 45, text: "Open Elective IV (HM) " },
          { credit: 3, value: 46, text: "Mini Project(7-sem)" },
          { credit: 11, value: 47, text: "major project + internship "},
],
        // ece
        options2: [
          { credit: null, value: null, text: "Please select an option" },
          { credit: 3, value: 1, text: "Engineering Mathematics-I" },
          { credit: 4, value: 2, text: "Basic Electrical Engg" },
          { credit: 4, value: 3, text: "Basic Electronics" },
          { credit: 4, value: 4, text: "Engineering Physics" },
          { credit: 4, value: 5, text: "Introduction to ‘C’ " },
          { credit: 3, value: 6, text: "Communication Skills" },
          { credit: 1, value: 7, text: "Intro to Electronics" },
          { credit: 1, value: 8, text: "Engineering Workshop" },
          { credit: 3, value: 9, text: "Engineering Mathematics-II" },
          { credit: 2, value: 10, text: "Engineering Graphics" },
          { credit: 3, value: 11, text: "PYTHON-I" },
          { credit: 5, value: 12, text: "Electronic Circuits and simulation" },
          { credit: 4, value: 13, text: "Network Analysis and Synthesis" },
          { credit: 3, value: 14, text: "Discourse of human values" },
          { credit: 1, value: 15, text: "Language Lab" },
          { credit: 0, value: 16, text: "Environmental Studies" },
          { credit: 3, value: 17, text: "Introduction to Logic" },
          { credit: 4, value: 18, text: "Electromagnetic Field Theory" },
          { credit: 5, value: 19, text: "Analog Communication Eng" },
          { credit: 5, value: 20, text: "Digital Electronics" },
          { credit: 1, value: 21, text: "Electronics Workshop Lab" },
          { credit: 4, value: 22, text: "Data Structure using c++" },
          { credit: 5, value: 23, text: "Linear Integrated Circuits and app." },
          { credit: 5, value: 24, text: "Digital Communication Eng" },
          { credit: 4, value: 25, text: "Antenna & wave propagation" },
          { credit: 5, value: 26, text: "Microprocessor Systems" },
          { credit: 5, value: 27, text: "Digital System Design using Verilog" },
          { credit: 2, value: 28, text: "MATLAB Programming" },
          { credit: 0, value: 29, text: "Constitutional of India" },
          { credit: 4, value: 30, text: "Signal Processing & Linear Systems" },
          { credit: 4, value: 31, text: "Control systems" },
          { credit: 5, value: 32, text: "Microwave Engineering" },
          {
            credit: 4,
            value: 33,
            text: "Embedded Electronics and Microcontroller",
          },
          { credit: 3, value: 34, text: "Computer Networks and security" },
          {
            credit: 2,
            value: 35,
            text: "Minor Project-I Hardware Based Projects",
          },
          { credit: 3, value: 36, text: "School Elective –I" },
          { credit: 3, value: 37, text: "Open Elective-I" },
          { credit: 3, value: 38, text: "School Elective –II" },
          { credit: 4, value: 39, text: "Iot" },
          { credit: 5, value: 40, text: "IC Fabrication and VLSI" },
          {
            credit: 4,
            value: 41,
            text: "Probability Theory and Stochastic Process",
          },
          {
            credit: 3,
            value: 42,
            text: "Minor Project-II Hardware Based Projects",
          },
          { credit: 3, value: 43, text: "Entrepreneurship Management" },
          { credit: 2, value: 44, text: "Summer Internship Evaluation" },
          { credit: 3, value: 45, text: "Open Elective-II" },
          { credit: 4, value: 46, text: "Optical Fiber Communication" },
          { credit: 3, value: 47, text: "School Elective – III" },
          { credit: 3, value: 48, text: "School Elective-IV" },
          { credit: 5, value: 49, text: "Project- Phase-I" },
          { credit: 0, value: 50, text: "Disaster management " },
          { credit: 9, value: 51, text: "Major Project" },
          { credit: 3, value: 52, text: "Open Elective-IV" },
          { credit: 12, value: 53, text: "Internship" },
        ],
        // mtech ece
        options3: [
          { credit: null, value: null, text: "Please select an option" },
          { credit: 4, value: 1, text: "Advanced Digital Communications" },
          {
            credit: 5,
            value: 2,
            text: "Signal Processing Techniques Applications",
          },
          { credit: 4, value: 3, text: "Integrated Circuit Design" },
          { credit: 5, value: 4, text: "Wireless Networks & protocols" },
          { credit: 4, value: 5, text: "Research Methodology" },
          { credit: 4, value: 6, text: "Microwave Circuit Design" },
          { credit: 4, value: 7, text: "Optical Switching & Networks" },
          {
            credit: 3,
            value: 8,
            text: "Synthesis & optimization of Digital Circuits",
          },
          { credit: 3, value: 9, text: "School Elective-I " },
          { credit: 3, value: 10, text: "School Elective-II " },
          { credit: 0, value: 11, text: "Discourse on Human Virtues" },
          { credit: 3, value: 12, text: "Open Elective-I" },
          { credit: 3, value: 13, text: "School Elective-III " },
          { credit: 4, value: 14, text: "Embedded System Design" },
          { credit: 3, value: 15, text: "Seminar" },
          { credit: 8, value: 16, text: "Project-Synopsis" },
          { credit: 20, value: 17, text: "Project-Dissertation" },
        ],
        // btech mech
        options4: [
          { credit: null, value: null, text: "Please select an option" },
          { credit: 3, value: 1, text: "Engineering Mathematics-I" },
          { credit: 1, value: 2, text: "Intro to Mechanical Engineering" },
          { credit: 4, value: 3, text: "Basic Electronics" },
          { credit: 4, value: 4, text: "Engineering Physics" },
          { credit: 4, value: 5, text: "Introduction to ‘C’ " },
          { credit: 3, value: 6, text: "Communication Skills" },
          { credit: 3, value: 7, text: "PYTHON-I" },
          { credit: 2, value: 8, text: "Engineering Graphics" },
          { credit: 3, value: 9, text: "Engineering Mathematics-II" },
          { credit: 3, value: 10, text: "Discourse of human values" },
          { credit: 4, value: 11, text: "Materials Science and Engineering" },
          { credit: 4, value: 12, text: "Engineering Mechanics" },
          { credit: 1, value: 13, text: "Language Lab-I-HS 0" },
          { credit: 1, value: 14, text: "Engineering Workshop" },
          { credit: 3, value: 15, text: "Introduction to Logic" },
          { credit: 4, value: 16, text: "Kinematics of Machines" },
          { credit: 4, value: 17, text: "Fluid Mechanics" },
          { credit: 5, value: 18, text: "Strength of Materials" },
          { credit: 4, value: 19, text: "Numerical Methods" },
          { credit: 3, value: 20, text: "Thermodynamics" },
          { credit: 4, value: 21, text: "Thermal Engineering " },
          { credit: 4, value: 22, text: "Manufacturing Processes" },
          { credit: 4, value: 23, text: "Dynamics of Machines" },
          { credit: 4, value: 24, text: "Machine Design " },
          { credit: 3, value: 25, text: "Mechanics of Materials" },
          { credit: 2, value: 26, text: "Constitutional of India" },
          { credit: 4, value: 27, text: "Heat and Mass Transfer " },
          { credit: 3, value: 28, text: "Industrial Engineering" },
          { credit: 3, value: 29, text: "Design of Machine Elements" },
          { credit: 3, value: 30, text: "Machining Processes" },
          { credit: 4, value: 31, text: "CAD/CAM" },
          { credit: 3, value: 32, text: "School Elective –I" },
          {
            credit: 3,
            value: 33,
            text: "Finite Element Analysis",
          },
          { credit: 2, value: 34, text: "Minor Project-I" },
          {
            credit: 3,
            value: 35,
            text: "Open Elective-I ",
          },
          { credit: 3, value: 36, text: "School Elective –II " },
          { credit: 4, value: 37, text: "Metrology and Measurements" },
          { credit: 4, value: 38, text: "Internal Combustion Engines" },
          { credit: 4, value: 39, text: "Mechanical Vibrations " },
          { credit: 3, value: 40, text: "Operations Research " },
          {
            credit: 2,
            value: 41,
            text: "Minor Project- Projects ",
          },
          {
            credit: 2,
            value: 42,
            text: "Advance CAD/CAM Lab",
          },
          { credit: 2, value: 43, text: "Summer Internship Evaluation" },
          { credit: 4, value: 44, text: "OFC (Compulsory)" },
          { credit: 3, value: 45, text: "Open Elective-II" },
          { credit: 4, value: 46, text: "Refrigeration and Air conditioning" },
          { credit: 4, value: 47, text: "Automobile Engineering " },
          { credit: 2, value: 48, text: "Disaster management" },
          { credit: 1, value: 49, text: "Colloquium " },
          { credit: 2, value: 50, text: "Project- Phase-I" },
          { credit: 9, value: 51, text: "Major Project" },
          { credit: 3, value: 52, text: "Open Elective-III" },
          { credit: 12, value: 53, text: "Internship" },
        ],
         //mtech CSE
        options5: [
          { credit: null, value: null, text: "Please select an option" },
          { credit: 4, value: 1, text: "Advanced Programming" },
          {
            credit: 4,
            value: 2,
            text: "Artificial Inteligence",
          },
          { credit: 4, value: 3, text: "Modeling and simulation" },
          { credit: 4, value: 4, text: "Network Management" },
          { credit: 4, value: 5, text: "Discrete Mathematical Structure" },
          { credit: 4, value: 6, text: "Advanced Computer Architecture" },
          { credit: 4, value: 7, text: "Neural Network & Probabilistic Reasoning" },
          {
            credit: 4,
            value: 8,
            text: "Advanced DBMS",
          },
          { credit: 4, value: 9, text: "Data Mining & DataWarehousing " },
          { credit: 4, value: 10, text: "Elective-1ImageProcessing" },
          { credit: 3, value: 11, text: "Research Methodology" },
          { credit: 3, value: 12, text: "Optimization Techniques" },
          { credit: 3, value: 13, text: "Information & CodingTheory" },
          { credit: 4, value: 14, text: "Elective II " },
          { credit: 4, value: 15, text: "Dissertation(preliminary)" },
          { credit: 3, value: 16, text: "OpenElective-III" },
          { credit: 20, value: 17, text: "Dissertation" },
          { credit: 4, value: 18, text: "Mobile & PervasiveComputing" },
          { credit: 4, value: 19, text: "Robotics" },
          { credit: 4, value: 20, text: "Embedded Systems" },
          { credit: 4, value: 19, text: "Multimedia and Virtual Reality" },
  ],
        //
        options6: [
          { credit: null, value: null, text: "Please select an option" },
          { credit: 5, value: 1, text: "Architectural Design-I" },
          { credit: 4, value: 2, text: "Building Materials & Construction -I" },
          { credit: 3, value: 3, text: "Building Structures-I" },
          { credit: 3, value: 4, text: "History of Architecture-I" },
          { credit: 4, value: 5, text: "Architectural Drawings - I " },
          { credit: 2, value: 6, text: "Basic Design & Visual Arts" },
          { credit: 2, value: 7, text: "Model Workshop" },
          { credit: 5, value: 8, text: "Architectural Design-II" },
          { credit: 4, value: 9, text: "Building Materials & Construction -II" },
          { credit: 3, value: 10, text: "Building Structures-II" },
          { credit: 3, value: 11, text: "History of Architecture-II" },
          { credit: 4, value: 12, text: "Architectural Drawings - II" },
          { credit: 2, value: 13, text: "Arts & Graphics" },
          { credit: 2, value: 14, text: "Surveying & Leveling" },
          { credit: 1, value: 15, text: "Language Lab - I" },
          { credit: 5, value: 16, text: "Architectural Design-III" },
          { credit: 4, value: 17, text: "Building Materials & Construction -III" },
          { credit: 3, value: 18, text: "Building Structures-III" },
          { credit: 3, value: 19, text: "History of Architecture-III" },
          { credit: 4, value: 20, text: "Computer Applications in Architecture - I" },
          { credit: 3, value: 21, text: "Climatology" },
          { credit: 3, value: 22, text: "Building Services-I" },
          { credit: 5, value: 23, text: "Architectural Design-IV" },
          { credit: 4, value: 24, text: "Building Materials & Construction -IV " },
          { credit: 3, value: 25, text: "Building Structures-IV" },
          { credit: 3, value: 26, text: "History of Architecture-IV" },
          { credit: 4, value: 27, text: "Computer Applications in Architecture - II" },
          { credit: 3, value: 28, text: "Theory of Design" },
          { credit: 3, value: 29, text: "Building Services-II" },
          { credit: 5, value: 30, text: "Architectural Design-V" },
          { credit: 4, value: 31, text: "Building Materials & Construction -V" },
          { credit: 3, value: 32, text: "Building Structures-V" },
          { credit: 3, value: 33, text: "Principles of Management"},
          { credit: 4, value: 34, text: "Computer Applications in Architecture - III" },
          { credit: 3, value: 35, text: "Acoustics & Lighting"},
          { credit: 3, value: 36, text: "Architectural Design-VI" },
          { credit: 5, value: 37, text: "Building Materials & Construction -VI" },
          { credit: 4, value: 38, text: "Building Structures-VI" },
          { credit: 3, value: 39, text: "Environmental Studies" },
          { credit: 3, value: 40, text: "Working Drawings" },
          { credit: 4, value: 41, text: "Discourse on Human Virtues"},
          { credit: 3, value: 42, text: "Specification & Estimation"},
          { credit: 20, value: 43, text: "Professional Training" },
          { credit: 6, value: 44, text: "Architectural Design-VIII" },
          { credit: 4, value: 45, text: "Advanced Building Construction Technology" },
          { credit: 3, value: 46, text: "Advanced Building Structure" },
          { credit: 3, value: 47, text: "Green Buildings" },
          { credit: 4, value: 48, text: "Landscape Design" },
          { credit: 3, value: 49, text: "Town Planning & Housing" },
          { credit: 7, value: 50, text: "Architectural Design - IX" },
          { credit: 4, value: 51, text: "Elective Course – I (Studio)" },
          { credit: 3, value: 52, text: "Elective Course – I (Theory)" },
          { credit: 2, value: 53, text: "Professional Practice" },
          { credit: 2, value: 54, text: "Low Cost Buildings" },
          { credit: 4, value: 55, text: "Dissertation" },
          { credit: 12, value: 56, text: "Architectural Design Thesis" },
          { credit: 3, value: 57, text: "Open Elective-I" },
          { credit: 3, value: 58, text: "Open Elective – II" },
          { credit: 3, value: 59, text: "Elective Course – II (Theory)" },
          { credit: 4, value: 60, text: "Elective Course – II (Studio)" },
        ],
  //Btech EE
   options7:[ { credit: null, value: null, text: "Please select an option" },
   { credit: 4, value: 1, text: "Fundamental of Electrical Engineering" },
   { credit: 3, value: 2, text: "Electrical Circuit Analysis" },
   { credit: 4, value: 3, text: "ELECTRICAL MACHINES-I" },
   { credit: 4, value: 4, text: "Electrical Measurement and Instrumentation" },
   { credit: 1, value: 5, text: "Electrical Measurement and Instrumentation Lab" },
   { credit: 1, value: 6, text: "ELECTRICAL WORKSHOP" },
   { credit: 4, value: 7, text: "Analog Electronic" },
   { credit: 4, value: 8, text: "ELECTRICAL MACHINES-II" },
   { credit: 3, value: 9, text: "Electric Materials" },
   { credit: 4, value: 10, text: "Signal and Systems" },
   { credit: 3, value: 11, text: "Control System in Electrical Application" },
   { credit: 3, value: 12, text: "POWER ELECTRONICS" },
   { credit: 5, value: 13, text: "Power System-I (Power Transmission & Distribution)" },
   { credit: 1, value: 14, text: "Power System-I Lab" },
   { credit: 3, value: 15, text: "Electric System Design" },
   { credit: 3, value: 16, text: "Power Plant Engineering" },
   { credit: 5, value: 17, text: "Power System-II (Power System Analysis)" },
   { credit: 1, value: 18, text: "Power System-II Lab" },
   { credit: 3, value: 19, text: "Power Quality and FACTS" },
  ],
      },
    };
  },
};
